import React from "react";

import { Stack, Typography, TypographyProps } from "@mui/material";
import styled from "@mui/material/styles/styled";

import { StepStatus } from "@app/analytics/onboarding/types";

import { Row, StackProps } from "@rui/Stack";

type StatusTypographyProps = TypographyProps & {
  status: StepStatus;
  active?: boolean;
};

const STATUS_TEXT: { [Status in StepStatus]: string } = {
  pending: "Not started",
  complete: "Completed",
  skipped: "Skipped",
};

export const Container = styled(
  (props: { clickable?: boolean } & StackProps) => (
    <Row variant="left" alignItems="flex-start" spacing={2} {...props} />
  )
)(({ clickable }) => ({
  position: "relative",
  zIndex: "10",
  cursor: clickable ? "pointer" : undefined,
}));

export const StepDescription = styled(Stack)(({ theme }) => ({
  justifyContent: "flex-start",
  alignSelf: "stretch",
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));

export const StatusText = styled(
  ({ status, active, ...props }: StatusTypographyProps) => {
    const text = active ? "In Progress" : STATUS_TEXT[status];
    return (
      <Typography variant="bodySecondaryReg" {...props}>
        {text}
      </Typography>
    );
  }
)(({ status, active, theme }) => ({
  color:
    status === "complete"
      ? theme.palette.chart.green.main
      : active
        ? theme.palette.shades.secondary[500]
        : theme.palette.shades.neutral[400],
  fontWeight: status === "complete" || active ? "500" : "400",
  padding: "2px 0",
}));

export const Title = styled(
  ({ status: _s, active: _a, ...props }: StatusTypographyProps) => (
    <Typography variant="bodyPrimaryReg" {...props} />
  )
)(({ active, theme }) => ({
  color: theme.palette.overlay.primary[24],
  fontWeight: active ? 500 : 400,
}));
